import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function Dashboard() {
  const [stats, setStats] = useState({
    students: 1245,
    trainers: 32,
    courses: 48,
    revenue: 12450,
    activeSubscriptions: 892,
    pendingRequests: 15,
    completionRate: 78,
    satisfactionRate: 92
  });

  const [recentActivities, setRecentActivities] = useState([
    { id: 1, type: 'student', action: 'سجل في دورة جديدة', name: 'أحمد محمد', time: 'منذ 10 دقائق', icon: '👨‍🎓' },
    { id: 2, type: 'trainer', action: 'أضاف دورة جديدة', name: 'سارة أحمد', time: 'منذ 30 دقيقة', icon: '👨‍🏫' },
    { id: 3, type: 'payment', action: 'تمت عملية دفع ناجحة', name: 'محمد خالد', amount: '$199', time: 'منذ ساعة', icon: '💰' },
    { id: 4, type: 'course', action: 'اكتملت دورة', name: 'تعليم البرمجة', time: 'منذ 3 ساعات', icon: '📚' },
    { id: 5, type: 'support', action: 'تم حل تذكرة دعم', name: 'مشكلة تقنية', time: 'منذ 5 ساعات', icon: '🛠️' }
  ]);

  const [popularCourses, setPopularCourses] = useState([
    { id: 1, title: 'تعليم البرمجة المتقدمة', category: 'تكنولوجيا', students: 245, rating: 4.8, revenue: '$5,850' },
    { id: 2, title: 'التسويق الرقمي', category: 'إدارة الأعمال', students: 198, rating: 4.7, revenue: '$4,950' },
    { id: 3, title: 'التصميم الجرافيكي', category: 'الفنون', students: 167, rating: 4.9, revenue: '$4,175' },
    { id: 4, title: 'اللغة الإنجليزية', category: 'اللغات', students: 143, rating: 4.6, revenue: '$3,575' }
  ]);

  // محاكاة تحديث الإحصائيات بشكل دوري
  useEffect(() => {
    const interval = setInterval(() => {
      setStats(prev => ({
        ...prev,
        students: prev.students + Math.floor(Math.random() * 3),
        activeSubscriptions: prev.activeSubscriptions + Math.floor(Math.random() * 2)
      }));
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  // تنسيقات CSS
  const styles = {
    container: {
      maxWidth: "1400px",
      margin: "0 auto",
      padding: "25px 20px"
    },
    header: {
      marginBottom: "30px"
    },
    welcomeSection: {
      backgroundColor: "white",
      borderRadius: "15px",
      padding: "30px",
      marginBottom: "30px",
      boxShadow: "0 5px 15px rgba(0, 0, 0, 0.05)",
      borderLeft: "5px solid #4b6cb7"
    },
    welcomeTitle: {
      margin: "0 0 10px 0",
      color: "#182848",
      fontSize: "28px",
      fontWeight: "700",
      display: "flex",
      alignItems: "center",
      gap: "12px"
    },
    welcomeText: {
      margin: "0 0 20px 0",
      color: "#6c757d",
      fontSize: "16px",
      lineHeight: "1.6"
    },
    dateTime: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      color: "#4b6cb7",
      fontSize: "14px",
      fontWeight: "500"
    },
    statsGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
      gap: "25px",
      marginBottom: "30px"
    },
    statCard: {
      backgroundColor: "white",
      borderRadius: "15px",
      padding: "25px",
      boxShadow: "0 5px 15px rgba(0, 0, 0, 0.05)",
      transition: "all 0.3s",
      position: "relative",
      overflow: "hidden"
    },
    statCardHover: {
      transform: "translateY(-5px)",
      boxShadow: "0 15px 30px rgba(0, 0, 0, 0.1)"
    },
    statHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "15px"
    },
    statIcon: {
      width: "50px",
      height: "50px",
      borderRadius: "12px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "24px"
    },
    statChange: {
      fontSize: "14px",
      fontWeight: "600",
      display: "flex",
      alignItems: "center",
      gap: "5px",
      padding: "5px 10px",
      borderRadius: "15px"
    },
    statValue: {
      margin: "0 0 5px 0",
      color: "#182848",
      fontSize: "32px",
      fontWeight: "700"
    },
    statTitle: {
      margin: "0 0 15px 0",
      color: "#6c757d",
      fontSize: "15px",
      fontWeight: "500"
    },
    statProgress: {
      height: "6px",
      backgroundColor: "#e9ecef",
      borderRadius: "3px",
      overflow: "hidden",
      marginTop: "15px"
    },
    statProgressBar: {
      height: "100%",
      borderRadius: "3px",
      transition: "width 1s ease"
    },
    twoColumns: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "30px",
      marginBottom: "30px"
    },
    activityCard: {
      backgroundColor: "white",
      borderRadius: "15px",
      padding: "25px",
      boxShadow: "0 5px 15px rgba(0, 0, 0, 0.05)",
      height: "100%"
    },
    cardTitle: {
      margin: "0 0 25px 0",
      color: "#182848",
      fontSize: "20px",
      fontWeight: "600",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      paddingBottom: "15px",
      borderBottom: "1px solid #e9ecef"
    },
    activityList: {
      listStyle: "none",
      margin: "0",
      padding: "0"
    },
    activityItem: {
      display: "flex",
      alignItems: "flex-start",
      gap: "15px",
      padding: "15px 0",
      borderBottom: "1px solid #f8f9fa",
      transition: "all 0.3s"
    },
    activityIcon: {
      width: "40px",
      height: "40px",
      borderRadius: "10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "18px",
      flexShrink: "0"
    },
    activityContent: {
      flex: "1"
    },
    activityText: {
      margin: "0 0 5px 0",
      color: "#182848",
      fontSize: "15px",
      lineHeight: "1.4"
    },
    activityMeta: {
      display: "flex",
      alignItems: "center",
      gap: "15px",
      fontSize: "13px",
      color: "#6c757d"
    },
    activityName: {
      fontWeight: "600",
      color: "#495057"
    },
    activityTime: {
      display: "flex",
      alignItems: "center",
      gap: "5px"
    },
    viewAllButton: {
      display: "block",
      textAlign: "center",
      padding: "12px",
      color: "#4b6cb7",
      textDecoration: "none",
      fontSize: "15px",
      fontWeight: "600",
      borderTop: "1px solid #e9ecef",
      marginTop: "10px",
      transition: "all 0.3s"
    },
    coursesTable: {
      width: "100%",
      borderCollapse: "collapse"
    },
    tableHeader: {
      textAlign: "right",
      padding: "15px",
      color: "#495057",
      fontWeight: "600",
      fontSize: "14px",
      borderBottom: "2px solid #e9ecef"
    },
    tableRow: {
      transition: "all 0.3s",
      borderBottom: "1px solid #f8f9fa"
    },
    tableCell: {
      padding: "15px",
      textAlign: "right",
      fontSize: "14px",
      color: "#495057"
    },
    courseTitleCell: {
      fontWeight: "600",
      color: "#182848"
    },
    categoryBadge: {
      backgroundColor: "#f8f9fa",
      color: "#495057",
      padding: "5px 12px",
      borderRadius: "15px",
      fontSize: "13px",
      fontWeight: "500",
      display: "inline-block"
    },
    ratingBadge: {
      display: "flex",
      alignItems: "center",
      gap: "5px",
      backgroundColor: "rgba(255, 193, 7, 0.1)",
      color: "#ffc107",
      padding: "5px 12px",
      borderRadius: "15px",
      fontSize: "13px",
      fontWeight: "600"
    },
    studentCount: {
      display: "flex",
      alignItems: "center",
      gap: "5px",
      color: "#4b6cb7"
    },
    revenueAmount: {
      color: "#28a745",
      fontWeight: "600"
    },
    quickActions: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
      gap: "20px",
      marginBottom: "30px"
    },
    actionCard: {
      backgroundColor: "white",
      borderRadius: "12px",
      padding: "25px",
      boxShadow: "0 5px 15px rgba(0, 0, 0, 0.05)",
      textAlign: "center",
      transition: "all 0.3s",
      cursor: "pointer",
      border: "1px solid #e9ecef",
      textDecoration: "none",
      display: "block"
    },
    actionIcon: {
      width: "60px",
      height: "60px",
      borderRadius: "12px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      margin: "0 auto 20px",
      fontSize: "28px"
    },
    actionTitle: {
      margin: "0 0 10px 0",
      color: "#182848",
      fontSize: "18px",
      fontWeight: "600"
    },
    actionDesc: {
      margin: "0",
      color: "#6c757d",
      fontSize: "14px",
      lineHeight: "1.5"
    },
    // ألوان مخصصة للإحصائيات
    studentColor: { bg: "rgba(75, 108, 183, 0.1)", icon: "#4b6cb7", change: "rgba(75, 108, 183, 0.2)", text: "#4b6cb7", progress: "#4b6cb7" },
    trainerColor: { bg: "rgba(40, 167, 69, 0.1)", icon: "#28a745", change: "rgba(40, 167, 69, 0.2)", text: "#28a745", progress: "#28a745" },
    courseColor: { bg: "rgba(255, 193, 7, 0.1)", icon: "#ffc107", change: "rgba(255, 193, 7, 0.2)", text: "#ffc107", progress: "#ffc107" },
    revenueColor: { bg: "rgba(220, 53, 69, 0.1)", icon: "#dc3545", change: "rgba(220, 53, 69, 0.2)", text: "#dc3545", progress: "#dc3545" },
    subscriptionColor: { bg: "rgba(111, 66, 193, 0.1)", icon: "#6f42c1", change: "rgba(111, 66, 193, 0.2)", text: "#6f42c1", progress: "#6f42c1" },
    requestColor: { bg: "rgba(23, 162, 184, 0.1)", icon: "#17a2b8", change: "rgba(23, 162, 184, 0.2)", text: "#17a2b8", progress: "#17a2b8" },
    completionColor: { bg: "rgba(253, 126, 20, 0.1)", icon: "#fd7e14", change: "rgba(253, 126, 20, 0.2)", text: "#fd7e14", progress: "#fd7e14" },
    satisfactionColor: { bg: "rgba(32, 201, 151, 0.1)", icon: "#20c997", change: "rgba(32, 201, 151, 0.2)", text: "#20c997", progress: "#20c997" }
  };

  // إحصائيات البيانات
  const statCards = [
    { 
      title: "إجمالي الطلاب", 
      value: stats.students.toLocaleString(), 
      change: "+12%", 
      icon: "👥", 
      color: styles.studentColor,
      progress: 85,
      link: "/academy-admin/students"
    },
    { 
      title: "إجمالي المدرّبين", 
      value: stats.trainers, 
      change: "+2", 
      icon: "👨‍🏫", 
      color: styles.trainerColor,
      progress: 65,
      link: "/academy-admin/trainers/create"
    },
    { 
      title: "الدورات النشطة", 
      value: stats.courses, 
      change: "+3", 
      icon: "📚", 
      color: styles.courseColor,
      progress: 75,
      link: "/academy-admin/categories"
    },
    { 
      title: "إجمالي الإيرادات", 
      value: `$${stats.revenue.toLocaleString()}`, 
      change: "+8%", 
      icon: "💰", 
      color: styles.revenueColor,
      progress: 90,
      link: "/academy-admin/plans"
    },
    { 
      title: "الاشتراكات النشطة", 
      value: stats.activeSubscriptions, 
      change: "+5%", 
      icon: "✅", 
      color: styles.subscriptionColor,
      progress: 70,
      link: "/academy-admin/plans"
    },
    { 
      title: "طلبات الانتظار", 
      value: stats.pendingRequests, 
      change: "−2", 
      icon: "⏳", 
      color: styles.requestColor,
      progress: 40,
      link: "/academy-admin/trainers/create"
    },
    { 
      title: "معدل إكمال الدورات", 
      value: `${stats.completionRate}%`, 
      change: "+3%", 
      icon: "🎯", 
      color: styles.completionColor,
      progress: stats.completionRate,
      link: "/academy-admin/students"
    },
    { 
      title: "معدل رضا العملاء", 
      value: `${stats.satisfactionRate}%`, 
      change: "+2%", 
      icon: "⭐", 
      color: styles.satisfactionColor,
      progress: stats.satisfactionRate,
      link: "/academy-admin/testimonials"
    }
  ];

  // إجراءات سريعة
  const quickActions = [
    { 
      title: "إضافة مدرّب جديد", 
      desc: "قم بإضافة مدرّب جديد للنظام", 
      icon: "👨‍🏫", 
      color: styles.trainerColor,
      link: "/academy-admin/trainers/create"
    },
    { 
      title: "إدارة الفئات", 
      desc: "تنظيم فئات الدورات التعليمية", 
      icon: "📁", 
      color: styles.courseColor,
      link: "/academy-admin/categories"
    },
    { 
      title: "عرض الطلاب", 
      desc: "عرض وإدارة قائمة الطلاب", 
      icon: "👥", 
      color: styles.studentColor,
      link: "/academy-admin/students"
    },
    { 
      title: "إعدادات التواصل", 
      desc: "تحديث روابط التواصل", 
      icon: "📞", 
      color: styles.requestColor,
      link: "/academy-admin/contacts"
    }
  ];

  // الحصول على التاريخ والوقت الحالي
  const getCurrentDateTime = () => {
    const now = new Date();
    const date = now.toLocaleDateString('ar-SA', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
    const time = now.toLocaleTimeString('ar-SA', {
      hour: '2-digit',
      minute: '2-digit'
    });
    return { date, time };
  };

  const { date, time } = getCurrentDateTime();

  // تأثيرات hover
  const handleCardHover = (e) => {
    e.currentTarget.style.transform = "translateY(-5px)";
    e.currentTarget.style.boxShadow = "0 15px 30px rgba(0, 0, 0, 0.1)";
    e.currentTarget.style.borderColor = "#4b6cb7";
  };

  const handleCardLeave = (e) => {
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow = "0 5px 15px rgba(0, 0, 0, 0.05)";
    e.currentTarget.style.borderColor = "#e9ecef";
  };

  const handleStatHover = (e, color) => {
    e.currentTarget.style.transform = "translateY(-5px)";
    e.currentTarget.style.boxShadow = "0 15px 30px rgba(0, 0, 0, 0.1)";
    e.currentTarget.style.borderLeft = `4px solid ${color.icon}`;
  };

  const handleStatLeave = (e) => {
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow = "0 5px 15px rgba(0, 0, 0, 0.05)";
    e.currentTarget.style.borderLeft = "none";
  };

  const handleRowHover = (e) => {
    e.currentTarget.style.backgroundColor = "#f8f9fa";
  };

  const handleRowLeave = (e) => {
    e.currentTarget.style.backgroundColor = "transparent";
  };

  const handleActivityHover = (e) => {
    e.currentTarget.style.backgroundColor = "#f8f9fa";
    e.currentTarget.style.paddingRight = "20px";
  };

  const handleActivityLeave = (e) => {
    e.currentTarget.style.backgroundColor = "transparent";
    e.currentTarget.style.paddingRight = "0";
  };

  return (
    <div style={styles.container}>
      {/* قسم الترحيب */}
      <div style={styles.welcomeSection}>
        <h1 style={styles.welcomeTitle}>
          <span style={{ fontSize: "32px" }}>👋</span>
          مرحبًا بك في لوحة تحكم الأكاديمية
        </h1>
        <p style={styles.welcomeText}>
          نحن سعداء بعودتك! هنا يمكنك متابعة أداء أكاديميتك، إدارة الدورات، المدرّبين، الطلاب، 
          وجميع الجوانب التعليمية. استخدم القائمة الجانبية للوصول السريع إلى جميع الأقسام.
        </p>
        <div style={styles.dateTime}>
          <span>📅 {date}</span>
          <span>🕒 {time}</span>
        </div>
      </div>

      {/* إجراءات سريعة */}
      <div style={styles.quickActions}>
        {quickActions.map((action, index) => (
          <Link
            key={index}
            to={action.link}
            style={styles.actionCard}
            onMouseEnter={handleCardHover}
            onMouseLeave={handleCardLeave}
          >
            <div style={{
              ...styles.actionIcon,
              backgroundColor: action.color.bg,
              color: action.color.icon
            }}>
              {action.icon}
            </div>
            <h3 style={styles.actionTitle}>{action.title}</h3>
            <p style={styles.actionDesc}>{action.desc}</p>
          </Link>
        ))}
      </div>

      {/* إحصائيات رئيسية */}
      <div style={styles.statsGrid}>
        {statCards.map((stat, index) => (
          <Link
            key={index}
            to={stat.link}
            style={styles.statCard}
            onMouseEnter={(e) => handleStatHover(e, stat.color)}
            onMouseLeave={handleStatLeave}
          >
            <div style={styles.statHeader}>
              <div style={{
                ...styles.statIcon,
                backgroundColor: stat.color.bg,
                color: stat.color.icon
              }}>
                {stat.icon}
              </div>
              <span style={{
                ...styles.statChange,
                backgroundColor: stat.color.change,
                color: stat.color.text
              }}>
                {stat.change}
              </span>
            </div>
            <h2 style={styles.statValue}>{stat.value}</h2>
            <p style={styles.statTitle}>{stat.title}</p>
            <div style={styles.statProgress}>
              <div style={{
                ...styles.statProgressBar,
                width: `${stat.progress}%`,
                backgroundColor: stat.color.progress
              }}></div>
            </div>
          </Link>
        ))}
      </div>

      {/* عمودين للنشاطات والدورات */}
      <div style={styles.twoColumns}>
        {/* النشاطات الأخيرة */}
        <div style={styles.activityCard}>
          <h2 style={styles.cardTitle}>
            <span>📋</span>
            النشاطات الأخيرة
          </h2>
          <ul style={styles.activityList}>
            {recentActivities.map((activity) => (
              <li 
                key={activity.id}
                style={styles.activityItem}
                onMouseEnter={handleActivityHover}
                onMouseLeave={handleActivityLeave}
              >
                <div style={{
                  ...styles.activityIcon,
                  backgroundColor: styles[`${activity.type}Color`]?.bg || styles.studentColor.bg,
                  color: styles[`${activity.type}Color`]?.icon || styles.studentColor.icon
                }}>
                  {activity.icon}
                </div>
                <div style={styles.activityContent}>
                  <p style={styles.activityText}>
                    <span style={styles.activityName}>{activity.name}</span> {activity.action}
                    {activity.amount && <span style={{ color: "#28a745", fontWeight: "600" }}> {activity.amount}</span>}
                  </p>
                  <div style={styles.activityMeta}>
                    <span style={styles.activityTime}>
                      <span>🕒</span>
                      {activity.time}
                    </span>
                  </div>
                </div>
              </li>
            ))}
          </ul>
          <Link to="/academy-admin/activities" style={styles.viewAllButton}>
            عرض جميع النشاطات →
          </Link>
        </div>

        {/* الدورات الأكثر شعبية */}
        <div style={styles.activityCard}>
          <h2 style={styles.cardTitle}>
            <span>🔥</span>
            الدورات الأكثر شعبية
          </h2>
          <table style={styles.coursesTable}>
            <thead>
              <tr>
                <th style={styles.tableHeader}>الدورة</th>
                <th style={styles.tableHeader}>التقييم</th>
                <th style={styles.tableHeader}>الطلاب</th>
                <th style={styles.tableHeader}>الإيرادات</th>
              </tr>
            </thead>
            <tbody>
              {popularCourses.map((course) => (
                <tr 
                  key={course.id}
                  style={styles.tableRow}
                  onMouseEnter={handleRowHover}
                  onMouseLeave={handleRowLeave}
                >
                  <td style={styles.tableCell}>
                    <div style={styles.courseTitleCell}>{course.title}</div>
                    <div style={styles.categoryBadge}>{course.category}</div>
                  </td>
                  <td style={styles.tableCell}>
                    <div style={styles.ratingBadge}>
                      <span>⭐</span>
                      {course.rating}
                    </div>
                  </td>
                  <td style={styles.tableCell}>
                    <div style={styles.studentCount}>
                      <span>👥</span>
                      {course.students}
                    </div>
                  </td>
                  <td style={styles.tableCell}>
                    <span style={styles.revenueAmount}>{course.revenue}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <Link to="/academy-admin/categories" style={styles.viewAllButton}>
            عرض جميع الدورات →
          </Link>
        </div>
      </div>

      {/* إضافة الأنيميشن */}
      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .welcome-section {
          animation: fadeInUp 0.5s ease-out;
        }
        
        .quick-action-card {
          animation: fadeInUp 0.6s ease-out;
        }
        
        .quick-action-card:nth-child(1) { animation-delay: 0.1s; }
        .quick-action-card:nth-child(2) { animation-delay: 0.2s; }
        .quick-action-card:nth-child(3) { animation-delay: 0.3s; }
        .quick-action-card:nth-child(4) { animation-delay: 0.4s; }
        
        .stat-card {
          animation: fadeInUp 0.7s ease-out;
        }
        
        .stat-card:nth-child(1) { animation-delay: 0.1s; }
        .stat-card:nth-child(2) { animation-delay: 0.2s; }
        .stat-card:nth-child(3) { animation-delay: 0.3s; }
        .stat-card:nth-child(4) { animation-delay: 0.4s; }
        .stat-card:nth-child(5) { animation-delay: 0.5s; }
        .stat-card:nth-child(6) { animation-delay: 0.6s; }
        .stat-card:nth-child(7) { animation-delay: 0.7s; }
        .stat-card:nth-child(8) { animation-delay: 0.8s; }
        
        .activity-card {
          animation: fadeInUp 0.8s ease-out;
        }
        
        @media (max-width: 1200px) {
          .stats-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
          
          .two-columns {
            grid-template-columns: 1fr !important;
            gap: 20px !important;
          }
        }
        
        @media (max-width: 768px) {
          .stats-grid {
            grid-template-columns: 1fr !important;
          }
          
          .quick-actions {
            grid-template-columns: 1fr !important;
          }
          
          .container {
            padding: 15px !important;
          }
          
          .stat-card, .activity-card, .welcome-section {
            padding: 20px !important;
          }
        }
        
        @media (max-width: 480px) {
          .welcome-title {
            font-size: 24px !important;
          }
          
          .stat-value {
            font-size: 28px !important;
          }
        }
      `}</style>
    </div>
  );
}